// TIBECO - Feronerie & Accesorii - MACO, ROTO, Hoppe - mânere, închizători, balamale, cilindri pentru ferestre și uși
import React, { useState } from 'react';
import { 
  Wrench, Search, AlertTriangle, TrendingDown, TrendingUp, Plus,
  Truck, BarChart, Package, ShoppingCart, Clock, CheckCircle,
  Lock, Key, Zap, Settings, Shield, Download, Edit, Star
} from 'lucide-react';
import Card from '../../components/Card';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';

const HardwareStock = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCategory, setFilterCategory] = useState('toate');
  const [isHardwareModalOpen, setIsHardwareModalOpen] = useState(false);
  const [selectedHardware, setSelectedHardware] = useState(null);
  const [isAddHardwareModalOpen, setIsAddHardwareModalOpen] = useState(false);

  // Mock data specific TIBECO - feronerie și accesorii realiste
  const mockHardwareStock = [
    {
      id: 1,
      product: 'Mâner Fereastră MACO Multi-Matic',
      category: 'Mânere Ferestre',
      brand: 'MACO',
      code: 'MM-348712-W',
      type: 'Mâner cu blocare',
      color: 'Alb',
      quantity: 145,
      unit: 'buc',
      minStock: 100,
      maxStock: 300,
      status: 'în stoc',
      location: 'Depozit Feronerie - Raft A1',
      supplier: 'MACO Romania SRL',
      price: '45 RON/buc',
      lastOrder: '2024-03-18',
      lastDelivery: '2024-03-22',
      consumption: '35 buc/săptămână',
      warranty: '5 ani',
      features: ['Blocare automată', 'Rezistență la coroziune', 'Design ergonomic'],
      applications: ['Ferestre PVC', 'Ferestre aluminiu', 'Uși balcon'],
      specifications: {
        material: 'Zamac cromat',
        load: 'Până la 130 kg',
        cycles: '20.000+ cicluri',
        temperature: '-30°C la +80°C'
      }
    },
    {
      id: 2,
      product: 'Sistem Închizător ROTO NT',
      category: 'Închizători',
      brand: 'ROTO',
      code: 'RT-NT-785',
      type: 'Închizător multipunct',
      color: 'Argintiu',
      quantity: 89,
      unit: 'set',
      minStock: 60,
      maxStock: 150,
      status: 'în stoc',
      location: 'Depozit Feronerie - Raft B2',
      supplier: 'ROTO Frank Romania',
      price: '185 RON/set',
      lastOrder: '2024-03-15',
      lastDelivery: '2024-03-20',
      consumption: '22 set/săptămână',
      warranty: '10 ani',
      features: ['Închidere multipunct', 'Securitate sporită', 'Funcționare silențioasă'],
      applications: ['Ferestre mari', 'Uși terasă', 'Sisteme premium'],
      specifications: {
        material: 'Oțel zincat',
        load: 'Până la 150 kg',
        cycles: '25.000+ cicluri',
        temperature: '-40°C la +70°C'
      }
    },
    {
      id: 3,
      product: 'Balamale Pivot Hoppe Secupact',
      category: 'Balamale',
      brand: 'Hoppe',
      code: 'HP-SEC-445',
      type: 'Balama pivot securizată',
      color: 'Inox',
      quantity: 67,
      unit: 'pereche',
      minStock: 50,
      maxStock: 120,
      status: 'stoc scăzut',
      location: 'Depozit Feronerie - Raft C1',
      supplier: 'Hoppe AG Romania',
      price: '125 RON/pereche',
      lastOrder: '2024-03-10',
      lastDelivery: '2024-03-14',
      consumption: '18 pereche/săptămână',
      warranty: '15 ani',
      features: ['Rezistență anti-efracție', 'Pivot ajustabil', 'Montaj rapid'],
      applications: ['Uși de intrare', 'Uși securizate', 'Aplicații premium'],
      specifications: {
        material: 'Inox 304',
        load: 'Până la 160 kg',
        cycles: '50.000+ cicluri',
        temperature: '-50°C la +100°C'
      }
    },
    {
      id: 4,
      product: 'Cilindru Profilat MACO Smartkey',
      category: 'Cilindri',
      brand: 'MACO',
      code: 'MC-SK-3045',
      type: 'Cilindru cu cheie inteligentă',
      color: 'Nichel satinat',
      quantity: 34,
      unit: 'buc',
      minStock: 25,
      maxStock: 80,
      status: 'comandă necesară',
      location: 'Depozit Feronerie - Raft D1',
      supplier: 'MACO Romania SRL',
      price: '285 RON/buc',
      lastOrder: '2024-02-28',
      lastDelivery: '2024-03-05',
      consumption: '12 buc/săptămână',
      warranty: '10 ani',
      features: ['Sistem anti-ciupire', 'Cheie inteligentă', '5 chei incluse'],
      applications: ['Uși de intrare premium', 'Sisteme securizate', 'Aplicații comerciale'],
      specifications: {
        material: 'Alamă nichelată',
        load: 'Clasă de securitate 4',
        cycles: '100.000+ cicluri',
        temperature: '-25°C la +70°C'
      }
    },
    {
      id: 5,
      product: 'Sistem Transmisie ROTO Drive',
      category: 'Transmisii',
      brand: 'ROTO',
      code: 'RT-DRV-680',
      type: 'Sistem transmisie integrată',
      color: 'Negru mat',
      quantity: 28,
      unit: 'sistem',
      minStock: 20,
      maxStock: 60,
      status: 'în stoc',
      location: 'Depozit Feronerie - Raft E2',
      supplier: 'ROTO Frank Romania',
      price: '320 RON/sistem',
      lastOrder: '2024-03-12',
      lastDelivery: '2024-03-17',
      consumption: '8 sistem/săptămână',
      warranty: '12 ani',
      features: ['Transmisie fără întrerupere', 'Funcționare premium', 'Montaj simplificat'],
      applications: ['Ferestre mari arhitecturale', 'Sisteme premium', 'Aplicații speciale'],
      specifications: {
        material: 'Oțel inoxidabil',
        load: 'Până la 200 kg',
        cycles: '30.000+ cicluri',
        temperature: '-30°C la +85°C'
      }
    },
    {
      id: 6,
      product: 'Mâner Ușă Hoppe Stockholm',
      category: 'Mânere Uși',
      brand: 'Hoppe',
      code: 'HP-STK-958',
      type: 'Mâner ușă pe placă',
      color: 'Argint antic',
      quantity: 156,
      unit: 'pereche',
      minStock: 80,
      maxStock: 200,
      status: 'în stoc',
      location: 'Depozit Feronerie - Raft F1',
      supplier: 'Hoppe AG Romania',
      price: '95 RON/pereche',
      lastOrder: '2024-03-20',
      lastDelivery: '2024-03-24',
      consumption: '28 pereche/săptămână',
      warranty: '20 ani',
      features: ['Design clasic elegant', 'Finisaj premium', 'Ergonomie superioară'],
      applications: ['Uși interioare premium', 'Aplicații decorative', 'Proiecte arhitecturale'],
      specifications: {
        material: 'Aluminiu anodizat',
        load: 'Utilizare intensivă',
        cycles: '1.000.000+ cicluri',
        temperature: '-20°C la +70°C'
      }
    }
  ];

  // Filtrare feronerie
  const filteredHardware = mockHardwareStock.filter(hardware => {
    const matchesSearch = hardware.product.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         hardware.brand.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         hardware.code.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesFilter = filterCategory === 'toate' || hardware.category === filterCategory;
    
    return matchesSearch && matchesFilter;
  });

  // Statistici KPI
  const totalHardwareTypes = mockHardwareStock.length;
  const totalQuantity = mockHardwareStock.reduce((acc, hardware) => acc + hardware.quantity, 0);
  const lowStockItems = mockHardwareStock.filter(hardware => hardware.status === 'stoc scăzut' || hardware.status === 'comandă necesară').length;
  const totalValue = mockHardwareStock.reduce((acc, hardware) => 
    acc + (hardware.quantity * parseFloat(hardware.price.replace(/[^\d]/g, ''))), 0
  );

  const columns = [
    { 
      key: 'product', 
      label: 'Produs Feronerie', 
      render: (hardware) => (
        <div className="flex items-center space-x-3">
          <div className="flex items-center justify-center w-10 h-10 bg-orange-100 dark:bg-orange-900/50 rounded-lg">
            <Wrench className="w-5 h-5 text-orange-600" />
          </div>
          <div>
            <div className="font-medium text-gray-900 dark:text-white">{hardware.product}</div>
            <div className="text-sm text-gray-500">{hardware.code} • {hardware.color}</div>
          </div>
        </div>
      )
    },
    { 
      key: 'brand', 
      label: 'Brand', 
      render: (hardware) => (
        <Badge 
          variant={
            hardware.brand === 'MACO' ? 'info' :
            hardware.brand === 'ROTO' ? 'success' : 
            hardware.brand === 'Hoppe' ? 'warning' : 'default'
          }
        >
          <Star className="w-3 h-3 mr-1" />
          {hardware.brand}
        </Badge>
      )
    },
    { 
      key: 'quantity', 
      label: 'Stoc Actual', 
      render: (hardware) => (
        <div className="text-right">
          <div className="font-semibold text-lg">{hardware.quantity}</div>
          <div className="text-sm text-gray-500">{hardware.unit}</div>
        </div>
      )
    },
    { 
      key: 'status', 
      label: 'Status', 
      render: (hardware) => (
        <Badge 
          variant={
            hardware.status === 'în stoc' ? 'success' : 
            hardware.status === 'stoc scăzut' ? 'warning' : 'error'
          }
        >
          {hardware.status === 'în stoc' && <CheckCircle className="w-3 h-3 mr-1" />}
          {hardware.status === 'stoc scăzut' && <AlertTriangle className="w-3 h-3 mr-1" />}
          {hardware.status === 'comandă necesară' && <ShoppingCart className="w-3 h-3 mr-1" />}
          {hardware.status ? hardware.status.charAt(0).toUpperCase() + hardware.status.slice(1) : 'Necunoscut'}
        </Badge>
      )
    },
    { 
      key: 'price', 
      label: 'Preț', 
      render: (hardware) => (
        <div className="text-right font-medium">
          {hardware.price}
        </div>
      )
    },
    { 
      key: 'consumption', 
      label: 'Consum', 
      render: (hardware) => (
        <div className="text-sm text-gray-600">
          {hardware.consumption}
        </div>
      )
    }
  ];

  const handleHardwareDetails = (hardware) => {
    setSelectedHardware(hardware);
    setIsHardwareModalOpen(true);
  };

  return (
    <div className="space-y-6">
      {/* Header cu acțiuni */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Feronerie & Accesorii</h1>
          <p className="text-gray-600 dark:text-gray-400">MACO, ROTO, Hoppe - mânere, închizători, balamale, cilindri pentru ferestre și uși</p>
        </div>
        <div className="flex items-center space-x-3">
          <button
            onClick={() => setIsAddHardwareModalOpen(true)}
            className="btn-primary flex items-center space-x-2"
          >
            <Plus className="w-4 h-4" />
            <span>Adaugă Feronerie</span>
          </button>
          <button className="btn-secondary flex items-center space-x-2">
            <Download className="w-4 h-4" />
            <span>Export Catalog</span>
          </button>
        </div>
      </div>

      {/* KPI-uri (4 cards cu statistici) */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <Card variant="stats" className="bg-gradient-to-br from-orange-500 to-orange-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-orange-100">Tipuri Feronerie</p>
              <p className="text-3xl font-bold">{totalHardwareTypes}</p>
            </div>
            <Wrench className="w-8 h-8 text-orange-200" />
          </div>
        </Card>

        <Card variant="stats" className="bg-gradient-to-br from-blue-500 to-blue-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-blue-100">Stoc Total</p>
              <p className="text-3xl font-bold">{totalQuantity}</p>
              <p className="text-blue-200 text-sm">piese</p>
            </div>
            <Package className="w-8 h-8 text-blue-200" />
          </div>
        </Card>

        <Card variant="stats" className="bg-gradient-to-br from-red-500 to-red-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-red-100">Stoc Scăzut</p>
              <p className="text-3xl font-bold">{lowStockItems}</p>
            </div>
            <AlertTriangle className="w-8 h-8 text-red-200" />
          </div>
        </Card>

        <Card variant="stats" className="bg-gradient-to-br from-green-500 to-green-600 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-green-100">Valoare Stoc</p>
              <p className="text-3xl font-bold">{Math.round(totalValue / 1000)}K</p>
              <p className="text-green-200 text-sm">RON</p>
            </div>
            <BarChart className="w-8 h-8 text-green-200" />
          </div>
        </Card>
      </div>

      {/* Filtre și căutare */}
      <Card>
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex-1">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Căutare feronerie, brand, cod produs..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="input pl-10 w-full"
              />
            </div>
          </div>
          
          <div className="sm:w-48">
            <select
              value={filterCategory}
              onChange={(e) => setFilterCategory(e.target.value)}
              className="input w-full"
            >
              <option value="toate">Toate Categoriile</option>
              <option value="Mânere Ferestre">Mânere Ferestre</option>
              <option value="Mânere Uși">Mânere Uși</option>
              <option value="Închizători">Închizători</option>
              <option value="Balamale">Balamale</option>
              <option value="Cilindri">Cilindri</option>
              <option value="Transmisii">Transmisii</option>
            </select>
          </div>
        </div>
      </Card>

      {/* Tabel feronerie */}
      <Card>
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
            Catalog Feronerie ({filteredHardware.length})
          </h2>
        </div>
        
        <Table 
          data={filteredHardware}
          columns={columns}
          onRowClick={handleHardwareDetails}
        />
      </Card>

      {/* Modal Detalii Feronerie */}
      <Modal
        isOpen={isHardwareModalOpen}
        onClose={() => setIsHardwareModalOpen(false)}
        title={selectedHardware ? `${selectedHardware.product}` : ''}
        size="xl"
      >
        {selectedHardware && (
          <div className="space-y-6">
            {/* Info generală */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div>
                  <label className="text-sm font-medium text-gray-500">Brand & Model</label>
                  <div className="flex items-center space-x-3 mt-1">
                    <Badge 
                      variant={
                        selectedHardware.brand === 'MACO' ? 'info' :
                        selectedHardware.brand === 'ROTO' ? 'success' : 'warning'
                      }
                    >
                      {selectedHardware.brand}
                    </Badge>
                    <span className="font-medium">{selectedHardware.code}</span>
                  </div>
                  <p className="text-sm text-gray-600 mt-1">{selectedHardware.type} • {selectedHardware.color}</p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Furnizor</label>
                  <p className="text-lg">{selectedHardware.supplier}</p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Locație Depozit</label>
                  <p className="text-lg">{selectedHardware.location}</p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Garanție</label>
                  <p className="text-lg font-semibold text-green-600">{selectedHardware.warranty}</p>
                </div>
              </div>
              
              <div className="space-y-4">
                <div>
                  <label className="text-sm font-medium text-gray-500">Status Stoc</label>
                  <div className="mt-1">
                    <Badge 
                      variant={
                        selectedHardware.status === 'în stoc' ? 'success' : 
                        selectedHardware.status === 'stoc scăzut' ? 'warning' : 'error'
                      }
                    >
                      {selectedHardware.status ? selectedHardware.status.charAt(0).toUpperCase() + selectedHardware.status.slice(1) : 'Necunoscut'}
                    </Badge>
                  </div>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Cantitate & Progres</label>
                  <div className="flex items-center space-x-3 mt-1">
                    <div className="flex-1 bg-gray-200 dark:bg-gray-700 rounded-full h-3">
                      <div 
                        className={`h-3 rounded-full ${
                          selectedHardware.quantity >= selectedHardware.minStock ? 'bg-green-500' : 'bg-red-500'
                        }`}
                        style={{ width: `${Math.min((selectedHardware.quantity / selectedHardware.maxStock) * 100, 100)}%` }}
                      ></div>
                    </div>
                    <span className="text-lg font-semibold">{selectedHardware.quantity} {selectedHardware.unit}</span>
                  </div>
                  <p className="text-sm text-gray-600 mt-1">
                    Min: {selectedHardware.minStock} • Max: {selectedHardware.maxStock}
                  </p>
                </div>
                <div>
                  <label className="text-sm font-medium text-gray-500">Preț & Consum</label>
                  <p className="text-lg font-semibold text-primary-600">{selectedHardware.price}</p>
                  <p className="text-sm text-gray-600">{selectedHardware.consumption}</p>
                </div>
              </div>
            </div>

            {/* Specificații tehnice */}
            <div className="border-t pt-6">
              <h3 className="text-lg font-semibold mb-4">Specificații Tehnice</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <Settings className="w-4 h-4 text-gray-500" />
                    <span className="text-sm font-medium text-gray-500">Material</span>
                  </div>
                  <p className="text-lg font-bold">{selectedHardware.specifications.material}</p>
                </div>
                
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <Package className="w-4 h-4 text-gray-500" />
                    <span className="text-sm font-medium text-gray-500">Sarcină Maximă</span>
                  </div>
                  <p className="text-lg font-bold">{selectedHardware.specifications.load}</p>
                </div>
                
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <Zap className="w-4 h-4 text-gray-500" />
                    <span className="text-sm font-medium text-gray-500">Cicluri Funcționare</span>
                  </div>
                  <p className="text-lg font-bold">{selectedHardware.specifications.cycles}</p>
                </div>
                
                <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                  <div className="flex items-center space-x-2 mb-2">
                    <Shield className="w-4 h-4 text-gray-500" />
                    <span className="text-sm font-medium text-gray-500">Temperatură</span>
                  </div>
                  <p className="text-lg font-bold">{selectedHardware.specifications.temperature}</p>
                </div>
              </div>
            </div>

            {/* Caracteristici */}
            <div className="border-t pt-6">
              <h3 className="text-lg font-semibold mb-4">Caracteristici Principale</h3>
              <div className="flex flex-wrap gap-2">
                {selectedHardware.features.map((feature, index) => (
                  <Badge key={index} variant="success">
                    <CheckCircle className="w-3 h-3 mr-1" />
                    {feature}
                  </Badge>
                ))}
              </div>
            </div>

            {/* Aplicații */}
            <div className="border-t pt-6">
              <h3 className="text-lg font-semibold mb-4">Aplicații Recomandate</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                {selectedHardware.applications.map((application, index) => (
                  <div key={index} className="bg-orange-50 dark:bg-orange-900/20 rounded-lg p-3">
                    <div className="flex items-center space-x-2">
                      <Wrench className="w-4 h-4 text-orange-600" />
                      <span className="text-sm font-medium">{application}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Istoricul comenzilor */}
            <div className="border-t pt-6">
              <h3 className="text-lg font-semibold mb-4">Istoric Comenzi</h3>
              <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <div className="flex items-center space-x-2 mb-2">
                      <ShoppingCart className="w-4 h-4 text-gray-500" />
                      <span className="text-sm font-medium text-gray-500">Ultima Comandă</span>
                    </div>
                    <p className="font-semibold">{selectedHardware.lastOrder}</p>
                  </div>
                  <div>
                    <div className="flex items-center space-x-2 mb-2">
                      <Truck className="w-4 h-4 text-gray-500" />
                      <span className="text-sm font-medium text-gray-500">Ultima Livrare</span>
                    </div>
                    <p className="font-semibold">{selectedHardware.lastDelivery}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Acțiuni */}
            <div className="border-t pt-6">
              <div className="flex flex-wrap gap-3">
                <button className="btn-primary flex items-center space-x-2">
                  <ShoppingCart className="w-4 h-4" />
                  <span>Comandă Stoc</span>
                </button>
                <button className="btn-secondary flex items-center space-x-2">
                  <Edit className="w-4 h-4" />
                  <span>Editează Detalii</span>
                </button>
                <button className="btn-secondary flex items-center space-x-2">
                  <BarChart className="w-4 h-4" />
                  <span>Istoric Consum</span>
                </button>
                <button className="btn-secondary flex items-center space-x-2">
                  <Download className="w-4 h-4" />
                  <span>Fișă Tehnică</span>
                </button>
              </div>
            </div>
          </div>
        )}
      </Modal>

      {/* Modal Adaugă Feronerie */}
      <Modal
        isOpen={isAddHardwareModalOpen}
        onClose={() => setIsAddHardwareModalOpen(false)}
        title="Adaugă Feronerie Nouă"
        size="xl"
      >
        <div className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="md:col-span-2">
              <label className="label">Nume Produs</label>
              <input type="text" className="input" placeholder="ex: Mâner Fereastră MACO Multi-Matic" />
            </div>
            <div>
              <label className="label">Categorie</label>
              <select className="input">
                <option>Selectează categoria...</option>
                <option>Mânere Ferestre</option>
                <option>Mânere Uși</option>
                <option>Închizători</option>
                <option>Balamale</option>
                <option>Cilindri</option>
                <option>Transmisii</option>
              </select>
            </div>
            <div>
              <label className="label">Brand</label>
              <select className="input">
                <option>Selectează brand-ul...</option>
                <option>MACO</option>
                <option>ROTO</option>
                <option>Hoppe</option>
                <option>Winkhaus</option>
                <option>Siegenia</option>
              </select>
            </div>
            <div>
              <label className="label">Cod Produs</label>
              <input type="text" className="input" placeholder="ex: MM-348712-W" />
            </div>
            <div>
              <label className="label">Tip</label>
              <input type="text" className="input" placeholder="ex: Mâner cu blocare" />
            </div>
            <div>
              <label className="label">Culoare</label>
              <select className="input">
                <option>Selectează culoarea...</option>
                <option>Alb</option>
                <option>Argintiu</option>
                <option>Negru mat</option>
                <option>Inox</option>
                <option>Nichel satinat</option>
                <option>Argint antic</option>
              </select>
            </div>
            <div>
              <label className="label">Furnizor</label>
              <select className="input">
                <option>Selectează furnizorul...</option>
                <option>MACO Romania SRL</option>
                <option>ROTO Frank Romania</option>
                <option>Hoppe AG Romania</option>
                <option>Winkhaus Romania</option>
              </select>
            </div>
            <div>
              <label className="label">Cantitate Inițială</label>
              <input type="number" className="input" placeholder="ex: 100" />
            </div>
            <div>
              <label className="label">Stoc Minim</label>
              <input type="number" className="input" placeholder="ex: 50" />
            </div>
            <div>
              <label className="label">Preț Unitar (RON)</label>
              <input type="number" className="input" placeholder="ex: 45" />
            </div>
            <div>
              <label className="label">Perioada Garanție</label>
              <input type="text" className="input" placeholder="ex: 5 ani" />
            </div>
            <div>
              <label className="label">Locație Depozit</label>
              <input type="text" className="input" placeholder="ex: Depozit Feronerie - Raft G1" />
            </div>
            <div className="md:col-span-2">
              <label className="label">Caracteristici (separate prin virgulă)</label>
              <textarea className="input" rows="2" placeholder="ex: Blocare automată, Rezistență la coroziune, Design ergonomic"></textarea>
            </div>
          </div>
          
          <div className="flex justify-end space-x-3 border-t pt-4">
            <button 
              onClick={() => setIsAddHardwareModalOpen(false)}
              className="btn-secondary"
            >
              Anulează
            </button>
            <button className="btn-primary">
              Adaugă în Catalog
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default HardwareStock;